import * as React from 'react'
import { Helmet } from 'react-helmet-async'
import AdminSideBar from '../../Containers/AdminSideBar'
import { CheckEDSContainer } from '../../Containers/CheckEDSContainer'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'

function CheckEDS() {
	const { t } = useTranslation()
	return (
		<>
			<div className='ContentsWrapper ContentsWrapper2'>
				<Helmet>
					<meta charSet='utf-8' />
					<title>
						{t('st:head.menu')} | {t('head.appTitle')}
					</title>
				</Helmet>
				<AdminSideBar />
				<CheckEDSContainer />
			</div>
		</>
	)
}

export default observer(CheckEDS)
